module.exports = __webpack_public_path__ + "img/stage2.77183d7e.png";